export const SET_ORDENES = "SET_ORDENES";
export const UPDATE_ORDEN_IN_ARRAY = "UPDATE_ORDEN_IN_ARRAY";
export const ADD_ORDEN_IN_ARRAY = "ADD_ORDEN_IN_ARRAY";
